import { render } from "./Identicon.vue?vue&type=template&id=17bd82d5"
import script from "./Identicon.vue?vue&type=script&lang=js"
export * from "./Identicon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__